
export const discardChanges = (intl, userAdministrationModal, modal) => {
  modal.openModal({
    modalType: 'ConfirmationModal',
    modalProps: {
      type: 'error',
      title: intl.formatMessage({
        id: 'unsavedChanges',
      }),
      content: intl.formatMessage({
        id: 'unsavedChangesDescription',
      }),
      confirmLabel: intl.formatMessage({
        id: 'discard',
      }),
      cancelLabel: intl.formatMessage({
        id: 'stay',
      }),
      onConfirm: () => {
        modal.closeModal();
        userAdministrationModal.setHasUnsavedChanges(false);
        userAdministrationModal.setSelectedUser(null);
        userAdministrationModal.setIsAddingUser(false);
        userAdministrationModal.setService(null);
      },
    },
  });
};
